<template>
    <b-modal ref="my-modal" okTitle="OK" cancelTitle="Cancel" @ok="emitOkEvent" @cancel="emitCancelEvent">
        {{message}}
    </b-modal>
</template>

<style scoped>
</style>

<script>
export default {
    name: 'ConfirmDialog',
    components: {
    },
    props: [],
    data() {
        return {
            message: null,
        }
    },
    computed: {
    },
    methods: {
        open(message) {
            this.message = message
            this.showModal()
        },
        isOpen() {
            return this.$refs['my-modal'].isVisible
        },
        showModal() {
            this.$refs['my-modal'].show()
        },
        hideModal() {
            this.$refs['my-modal'].hide()
        },
        countChanged(event) {
            this.count = event.value
        },
        emitOkEvent() {
            this.$emit('choosed', {
                ok: true,
            })
        },
        emitCancelEvent() {
            this.$emit('choosed', {
                ok: false,
            })
        },
    },
}
</script>
